/**
 * @author      luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright   Copyright (c) 2022, Zumper
 * @description amenity filter constants for STR
 */

import { BuildingAmenity, ListingAmenity } from '@zcode/enums'
import { AIRBNB_FRIENDLY_LABEL } from './filterConstants'

// TODO: replace with enum
export const STR_HOT_TUB_KEY = `l-${ListingAmenity.HOT_TUB}` as const
export const STR_PRIVATE_POOL_KEY = `l-${ListingAmenity.PRIVATE_POOL}` as const
export const STR_HEATED_POOL_OR_INDOOR_POOL_KEY = `l-${ListingAmenity.HEATED_INDOOR_POOL}` as const

// Location keys
export const BEACH_KEY = `l-${ListingAmenity.BEACH}` as const
export const LAKE_KEY = `l-${ListingAmenity.LAKE}` as const
export const WATERFRONT_KEY = `l-${ListingAmenity.WATERFRONT}` as const
export const MOUNTAINS_KEY = `l-${ListingAmenity.MOUNTAINS}` as const
export const OCEAN_KEY = `l-${ListingAmenity.OCEAN}` as const
export const SKI_IN_SKI_OUT_KEY = `l-${ListingAmenity.SKI_IN_SKI_OUT}` as const

export const AIR_CONDITION_KEY = `l-${ListingAmenity.AIR_CONDITIONING}` as const
export const ASSIGNED_PARKING_KEY = `l-${ListingAmenity.ASSIGNED_PARKING}` as const
export const BALCONY_KEY = `l-${ListingAmenity.BALCONY}` as const
export const BREAKFAST_INCLUDED_KEY = `l-${ListingAmenity.BREAKFAST_INCLUDED}` as const
export const CABLE_KEY = `l-${ListingAmenity.CABLE}` as const
export const CENTRAL_HEAT_KEY = `l-${ListingAmenity.CENTRAL_HEAT}` as const
export const COFFEE_TEA_MAKER_KEY = `l-${ListingAmenity.COFFEE_TEA_MAKER}` as const
export const DISHWASHER_KEY = `l-${ListingAmenity.DISHWASHER}` as const
export const DOOR_PERSON_KEY = `b-${BuildingAmenity.DOOR_PERSON}` as const
export const ELEVATOR_KEY = `b-${BuildingAmenity.ELEVATOR}` as const
export const EV_CHARGING_KEY = `l-${ListingAmenity.EV_CHARGING}` as const
export const FIREPLACE_KEY = `l-${ListingAmenity.FIREPLACE}` as const
export const FREE_PARKING_KEY = `l-${ListingAmenity.FREE_PARKING}` as const
export const FURNISHED_KEY = 'l-13' as const
export const GARAGE_PARKING_KEY = `b-${BuildingAmenity.GARAGE_PARKING}` as const
export const GYM_KEY = `b-${BuildingAmenity.FITNESS_CENTER}` as const
export const HARDWOOD_FLOOR_KEY = 'l-11' as const
export const HIGH_CEILINGS_KEY = `l-${ListingAmenity.HIGH_CEILINGS}` as const
export const HOUSEKEEPING_KEY = `l-${ListingAmenity.HOUSEKEEPING}` as const
export const KITCHEN_KEY = `l-${ListingAmenity.KITCHEN}` as const
export const LAUNDRY_BUILDING_KEY = `b-${BuildingAmenity.ON_SITE_LAUNDRY}` as const
export const LAUNDRY_IN_UNIT_KEY = `l-${ListingAmenity.IN_UNIT_LAUNDRY}` as const
export const LAUNDRY_KEY = `l-${ListingAmenity.ON_SITE_LAUNDRY}` as const
export const MICROWAVE_KEY = `l-${ListingAmenity.MICROWAVE}` as const
export const OUTDOOR_SPACE_KEY = `b-${BuildingAmenity.OUTDOOR_SPACE}` as const
export const OVEN_KEY = `l-${ListingAmenity.OVEN}` as const
export const POOL_KEY = `b-${BuildingAmenity.SWIMMING_POOL}` as const
export const POOL_LISTING_KEY = `l-${ListingAmenity.POOL}` as const
export const TOILETRIES_KEY = `l-${ListingAmenity.TOILETRIES}` as const
export const TV_KEY = `l-${ListingAmenity.TV}` as const
export const WHEELCHAIR_KEY = `b-${BuildingAmenity.WHEELCHAIR_ACCESSIBLE}` as const
export const WIFI_KEY = `l-${ListingAmenity.WIFI}` as const
export const WORKSPACE_KEY = `l-${ListingAmenity.WORKSPACE}` as const

export const LAUNDRY_OR_KEY = 'OR-100'
export const PARKING_OR_KEY = 'OR-101'
export const POOL_OR_KEY = 'OR-102'
export const OUTDOOR_SPACE_OR_KEY = 'OR-103'
export const BUILDING_LAUNDRY_OR_KEY = 'OR-104'

// Or amenities keys
export const OR_LAUNDRY_BUILDING_KEY = `b${BuildingAmenity.ON_SITE_LAUNDRY}` as const
export const OR_LAUNDRY_IN_UNIT_KEY = `l${ListingAmenity.IN_UNIT_LAUNDRY}` as const
export const OR_LAUNDRY_KEY = `l${ListingAmenity.ON_SITE_LAUNDRY}` as const

export const OR_ASSIGNED_PARKING_KEY = `l${ListingAmenity.ASSIGNED_PARKING}` as const
export const OR_FREE_PARKING_KEY = `l${ListingAmenity.FREE_PARKING}` as const
export const OR_GARAGE_PARKING_KEY = `b${BuildingAmenity.GARAGE_PARKING}` as const

export const OR_POOL_KEY = `b${BuildingAmenity.SWIMMING_POOL}` as const
export const OR_POOL_LISTING_KEY = `l${ListingAmenity.POOL}` as const

export const OR_BALCONY_KEY = `l${ListingAmenity.BALCONY}` as const
export const OR_GARDEN_KEY = `l${ListingAmenity.GARDEN}` as const
export const OR_DECK_KEY = `l${ListingAmenity.DECK}` as const
export const OR_ROOF_DECK_KEY = `b${BuildingAmenity.ROOF_DECK}` as const
export const OR_OUTDOOR_SPACE_KEY = `b${BuildingAmenity.OUTDOOR_SPACE}` as const

export const orAmenitiesLaundry = [
  OR_LAUNDRY_KEY,
  OR_LAUNDRY_IN_UNIT_KEY,
  OR_LAUNDRY_BUILDING_KEY,
] as const

export const orAmenitiesBuildingLaundry = [OR_LAUNDRY_KEY, OR_LAUNDRY_BUILDING_KEY] as const

export const orAmenitiesParking = [
  OR_ASSIGNED_PARKING_KEY,
  OR_FREE_PARKING_KEY,
  OR_GARAGE_PARKING_KEY,
] as const

export const orAmenitiesPool = [OR_POOL_KEY, OR_POOL_LISTING_KEY] as const

export const orAmenitiesOutdoorSpaces = [
  OR_BALCONY_KEY,
  OR_GARDEN_KEY,
  OR_DECK_KEY,
  OR_ROOF_DECK_KEY,
  OR_OUTDOOR_SPACE_KEY,
] as const

export const OR_AMENITIES = {
  [PARKING_OR_KEY]: orAmenitiesParking,
  [LAUNDRY_OR_KEY]: orAmenitiesLaundry,
  [POOL_OR_KEY]: orAmenitiesPool,
  [OUTDOOR_SPACE_OR_KEY]: orAmenitiesOutdoorSpaces,
  [BUILDING_LAUNDRY_OR_KEY]: orAmenitiesBuildingLaundry,
} as const

export const basicAmenities = {
  [AIR_CONDITION_KEY]: 'Air conditioning',
  [LAUNDRY_OR_KEY]: 'Laundry',
  [CENTRAL_HEAT_KEY]: 'Central heating',
  [PARKING_OR_KEY]: 'Parking',
  [TV_KEY]: 'TV',
  [WIFI_KEY]: 'Wifi',
} as const

export const moreAmenities = {
  [STR_HOT_TUB_KEY]: 'Hot tub',
  [POOL_OR_KEY]: 'Pool',
  [STR_PRIVATE_POOL_KEY]: 'Private pool',
  [STR_HEATED_POOL_OR_INDOOR_POOL_KEY]: 'Heated pool or indoor pool',
  [DISHWASHER_KEY]: 'Dishwasher',
  [EV_CHARGING_KEY]: 'EV charging',
  [BREAKFAST_INCLUDED_KEY]: 'Breakfast/Meals',
  [TOILETRIES_KEY]: 'Bathroom amenities',
  [MICROWAVE_KEY]: 'Microwave',
  [ELEVATOR_KEY]: 'Elevator',
  [GYM_KEY]: 'Gym',
  [FIREPLACE_KEY]: 'Fireplace',
  [HOUSEKEEPING_KEY]: 'Housekeeping',
  [COFFEE_TEA_MAKER_KEY]: 'Tea/coffee maker',
  [OVEN_KEY]: 'Oven',
  [DOOR_PERSON_KEY]: 'Door person',
  // [CABLE_KEY]: 'Cable',
} as const

export const locationAmenities = {
  [LAKE_KEY]: 'Lake',
  [WATERFRONT_KEY]: 'Waterfront',
  [BEACH_KEY]: 'Beach',
  [OCEAN_KEY]: 'Oceanfront',
  [SKI_IN_SKI_OUT_KEY]: 'Ski in/Ski out',
  [MOUNTAINS_KEY]: 'Mountains',
} as const

export const basicAmenitiesKeys = [
  AIR_CONDITION_KEY,
  LAUNDRY_KEY,
  CENTRAL_HEAT_KEY,
  LAUNDRY_BUILDING_KEY,
  TV_KEY,
  LAUNDRY_IN_UNIT_KEY,
  ASSIGNED_PARKING_KEY,
  GARAGE_PARKING_KEY,
  WIFI_KEY,
] as const

export const accessibilityAmenityKeys = [DOOR_PERSON_KEY, ELEVATOR_KEY, WHEELCHAIR_KEY] as const

export const otherSpacesAmenities = {
  [KITCHEN_KEY]: 'Kitchen',
  [OUTDOOR_SPACE_OR_KEY]: 'Outdoor space',
  [WORKSPACE_KEY]: 'Workspace',
} as const

export const popularAmenities = {
  [LAUNDRY_IN_UNIT_KEY]: 'In unit laundry',
  [DISHWASHER_KEY]: 'Dishwasher',
  [AIR_CONDITION_KEY]: 'A/C',
  [GARAGE_PARKING_KEY]: 'Garage parking',
} as const

export const popularAmenitiesArr = [
  'A/C',
  'Available now',
  'Dishwasher',
  'Garage parking',
  'Highest rated',
  'In unit laundry',
  AIRBNB_FRIENDLY_LABEL,
  'New construction',
] as const
